import mutations from './employeeIdImport.mutations'
import actions from './employeeIdImport.actions'
import getters from './employeeIdImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
